var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0C0.895431 0 0 0.895431 0 2V8H8V0H2ZM2 1C1.44772 1 1 1.44772 1 2V7H7V1H2ZM3 3H5V5H3V3ZM18 2C18 0.895431 17.1046 0 16 0H10V8L18 8V2ZM17 2C17 1.44772 16.5523 1 16 1L11 1V7L17 7V2ZM15 3V5H13V3H15ZM14 17V14L17 14C17.5523 14 18 14.4477 18 15V17C18 17.5523 17.5523 18 17 18H15C14.4477 18 14 17.5523 14 17ZM12 14H14V12H16V10H14V12H12V10H10V12H12V14ZM12 14H10V16H12V14ZM0 16C0 17.1046 0.895431 18 2 18H8L8 10H0V16ZM1 16C1 16.5523 1.44772 17 2 17H7L7 11H1L1 16ZM17 15H15V17H17V15ZM3 15V13H5V15H3Z",
    fill: "#0E0E0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/qr.bd198062.svg";
export { ForwardRef as ReactComponent };